export const TITLE_LIST = [
  { level: 1, title: "Weakest Hunter of Mankind" },
  { level: 2, title: "E-Rank" },
  { level: 3, title: "D-Rank" },
  { level: 4, title: "C-Rank" },
  { level: 5, title: "B-Rank" },
  { level: 6, title: "A-Rank" },
  { level: 7, title: "S-Rank" },
  { level: 8, title: "Wolf Slayer" },
  { level: 9, title: "Demon Hunter" },
  { level: 10, title: "One Who Overcomes Adversity" },
  { level: 11, title: "King of the Dead" },
  { level: 12, title: "Strongest Hunter of Mankind" },
  { level: 13, title: "Shadow Monarch" }
];
